// ─── hooks/useStablePolling.js ──────────────────────────────────────────────
// Polling that NEVER restarts just because the callback changed.
// Uses a ref so the interval is stable but always calls the latest function.

import { useEffect, useRef } from "react";

export function useStablePolling(asyncFn, delay, enabled) {
  const fnRef = useRef(asyncFn);
  const timerRef = useRef(null);
  const activeRef = useRef(false);

  // Always keep fnRef current — no restart needed
  useEffect(() => {
    fnRef.current = asyncFn;
  }, [asyncFn]);

  useEffect(() => {
    if (!enabled) {
      activeRef.current = false;
      clearTimeout(timerRef.current);
      return;
    }

    activeRef.current = true;

    const run = async () => {
      if (!activeRef.current) return;
      try {
        await fnRef.current();
      } catch (err) {
        console.error("Polling error:", err);
      }
      if (activeRef.current) {
        timerRef.current = setTimeout(run, delay);
      }
    };

    run();

    return () => {
      activeRef.current = false;
      clearTimeout(timerRef.current);
    };
  }, [enabled, delay]); // ← asyncFn intentionally excluded
}